import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-help-container',
  templateUrl: './help-container.component.html',
  styles: [
  ]
})
export class HelpContainerComponent implements OnInit {
  @Input() value: string;
  @Input() isLoading: boolean = false;
  @Output() onCreate: EventEmitter<string> = new EventEmitter<string>();

  constructor() { }

  ngOnInit(): void {
  }

  create() {
    this.onCreate.emit();
  }
}
